import { Dialog } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ICON } from "../../assets";
import confs from "../../configurations";
import { navigate } from "../../routes";
import { admin } from "../../routes/admin";
import { main } from "../../routes/main";
import { price, round2 } from "../../utils";
import { useAuth } from "../Auth/useAuth";
import CurrentCartItems from "../Carts/CurrentCartItems/CurrentCartItems";
import { useCart } from "../Carts/useCart";
import useTranslations from "../Translations/useTranslations";
import Box from "../ui/Box";
import Button from "../ui/Buttons";
import UiButton from "../ui/UiButton";
import UiCheckbox from "../ui/UiCheckbox";
import UiIcon from "../ui/UiIcon";
import ClientRecap from "./ClientRecap";
import "./OrderSynthese.css";
import ProspectRecap from "./ProspectRecap";

const { URL_GED } = confs;

function OrderSynthese({ goBack = () => { } }) {
  const [{ user }, { isRoleOperator }] = useAuth();
  const [{ current_cart }, cartSDK] = useCart(user.client_profile?.id);

  const [creatingOrder, isCreatingOrder] = useState(false);
  const [orderCompleted, isOrderComplete] = useState(false);
  const [CGVValid, setCGVValid] = useState(false);
  const [isErrorOnCreateOrder, setErrorOnCreateOrder] = useState(null);
  const trl = useTranslations();
  const [clientRecapValidData, setclientRecapValid] = useState({
    CODADR_LIV: false,
    CODADR_FAC: false,
    DATE_LIV: false,
    refcliextension: false,
  });

  const [prospectRecapValidData, setProspectRecapValid] = useState({
    PROSPECT_EMAIL: false,
    PROSPECT_ADR_LIV: false,
    PROSPECT_ADR_FACT: false,
    PROSPECT_SIRET: false,
    PROSPECT_TVA: false,
    DATE_LIV: false,
    REF_CLI: false,
    COMMENTAIRE_LIBRE: false,
  });

  const { client } = current_cart || {};

  useEffect(() => {
    if (!current_cart || !client) {
      navigate.goBack();
    }
  }, [current_cart]);

  const cart_data = cartSDK.getCartData();
  const max_mt_plv_offert = cartSDK.getMaxMtPLVOffert(cart_data);
  const mt_plv_in_cart = Math.round(cart_data?.cumul_plv_in_cart * 100) / 100;

  function extractClientDetails() {
    const { header } = current_cart;
    const REF_CLI_list = header.REF_CLI ? header.REF_CLI.split(" ") : [];
    const refcliextension = REF_CLI_list[4]
      ? REF_CLI_list[3].trim().toUpperCase()
      : "";
    return refcliextension;
  }

  function headerthrowError() {
    const { header } = current_cart;
    const refcliextension = extractClientDetails();
    const isNotvalidRefCliExt = (text) => {
      const date = ` ${new Date()
        .getDate()
        .toString()
        .padStart(2, "0")}/${new Date().getMonth()}`;
      const web = "Web";
      return [date, web].includes(text) || text === "";
    };
    if (
      user.data.cmd_facultative !== "O" &&
      (!header.REF_CLI ||
        header.REF_CLI.indexOf("  ") > -1 ||
        header.REF_CLI.endsWith(" "))
    ) {
      setclientRecapValid({
        CODADR_LIV: false,
        CODADR_FAC: false,
        DATE_LIV: false,
        refcliextension: false,
      });
      setProspectRecapValid({
        PROSPECT_EMAIL: false,
        PROSPECT_ADR_LIV: false,
        PROSPECT_ADR_FACT: false,
        PROSPECT_SIRET: false,
        PROSPECT_TVA: false,
        DATE_LIV: false,
        REF_CLI: false,
        COMMENTAIRE_LIBRE: false,
      });
      return false;
    }
    if (client.PROSPECT === "O") {
      setProspectRecapValid({
        PROSPECT_EMAIL: !header.PROSPECT_EMAIL,
        PROSPECT_ADR_LIV: !header.PROSPECT_ADR_LIV,
        PROSPECT_ADR_FACT: false,
        PROSPECT_SIRET: !header.PROSPECT_SIRET,
        PROSPECT_TVA: false,
        DATE_LIV: !header.DATE_LIV,
        REF_CLI: false,
        COMMENTAIRE_LIBRE: false,
      });
      return (
        header.PROSPECT_EMAIL &&
        header.PROSPECT_ADR_LIV &&
        header.DATE_LIV &&
        CGVValid &&
        header.PROSPECT_SIRET
      );
    } else {
      setclientRecapValid({
        CODADR_LIV: !header.CODADR_LIV,
        CODADR_FAC: !header.CODADR_FAC,
        DATE_LIV: !header.DATE_LIV,
        refcliextension: false,
      });
      return (
        header.DATE_LIV && CGVValid && header.CODADR_LIV && header.CODADR_FAC
      );
    }
  }

  const getMtTotalHT = () => {
    if (!current_cart) return 0;
    const mt_max_offert = max_mt_plv_offert;
    const mt_total = cart_data.mt_total;
    const packs = current_cart.packs;

    const remiseCommercial = round2(parseFloat(current_cart.header?.MT_REMISE || 0));
    const remisePlv = cart_data.remise_plv || 0;

    const toDeduct = packs.reduce(
      (a, b) => (a += b.mt_remise * b.qte_commande),
      0,
    );



    return round2(
      mt_total - remisePlv - remiseCommercial - toDeduct,
    );
  };

  const getFraisPort = () => {
    if (!client) return 0;
    const mt_port_base = client.has_commande
      ? client.groupe_tarifaire.MT_PORT2
      : client.groupe_tarifaire.MT_PORT1;
    const franco_port = client.groupe_tarifaire.MT_FRANCO2;

    const total_HT = getMtTotalHT();

    const frais_port = total_HT >= franco_port ? 0 : mt_port_base;

    return frais_port;
  };
  const thresHoldMinValue = () => {
    if (!current_cart) return 0;
    const { MT_MINI_COMMANDE } = current_cart.client.groupe_tarifaire;
    return MT_MINI_COMMANDE;
  };
  const orderValueLimit = thresHoldMinValue();

  useEffect(() => {
    cartSDK.changeHeader("MT_PORT", getFraisPort());
  }, [getFraisPort()]);

  const getTotalWithPort = () => round2(getMtTotalHT() + getFraisPort());

  const CGVLabel = (
    <span>
      {trl.message("FinishOrderPage.CGVCheckboxText")}{" "}
      <a
        target="_blank"
        href={
          URL_GED +
          "/Edoc/" +
          current_cart?.client.groupe_tarifaire?.CODGRT +
          "/cgv" +
          current_cart?.client.groupe_tarifaire?.CODGRT +
          ".pdf"
        }
        download
      >
        {trl.message("FinishOrderPage.CGVDownloadLink")}
      </a>{" "}
      *
    </span>
  );

  const MT_PORT = getFraisPort();

  function showOrderSuccessDialog() {
    if (!current_cart) return null;
    return (
      <React.Fragment>
        <Dialog open={orderCompleted || current_cart.generated === true}>
          <Box p={1.5} jc="center">
            <div>
              <div style={{ textAlign: "center" }}>
                {isErrorOnCreateOrder
                  ? isErrorOnCreateOrder
                  : trl.message("FinishOrderPage.generateOrderSuccessed", {
                    buyerEmail: current_cart.email_receiver,
                  })}
              </div>
              <Box m={[1, 0, 0, 0]} jc="center">
                <Button
                  label={trl.message("FinishOrderPage.removeCartAndGoHome")}
                  icon="home"
                  onClick={() => {
                    navigate.push(main.HOME);
                    cartSDK.removeCartFromCartList({
                      creator: user.client_profile?.id,
                      _id: current_cart._id,
                    });
                  }}
                />
              </Box>
            </div>
          </Box>
        </Dialog>
      </React.Fragment>
    );
  }

  function renderMontantSummary() {
    function renderMontantDetail(label, value) {
      let formattedValue = value;
      if (value <= 0) {
        formattedValue = "offerts !";
      } else {
        formattedValue = price(value) + " €";
      }
      return (
        <React.Fragment>
          <div className="montant-info-item">
            <span className="montant-info-label">{label}</span>
            <span className="montant-info-value">{formattedValue}</span>
          </div>
        </React.Fragment>
      );
    }
    // Montant HT
    const ht_label = trl.message("FinishOrderPage.excludingTaxesAmount");
    const ht = getTotalWithPort();
    // Montant TVA
    const tva_label = trl.message("FinishOrderPage.valueAddedTaxAmount");
    const tva = round2((ht * client?.tva?.TXTVA) / 100);
    // Montant TTC
    const ttc_label = trl.message("FinishOrderPage.includingTaxesAmount");
    const ttc = round2(tva + ht);

    return (
      <React.Fragment>
        <div className="montant-info-container">
          {renderMontantDetail(ht_label, ht)}
          {renderMontantDetail(tva_label, tva)}
          {renderMontantDetail(ttc_label, ttc)}
        </div>
      </React.Fragment>
    );
  }

  function renderRemiseEnPied() {
    if (!current_cart.header) return null;
    const label = trl.message("FinishOrderPage.rebateAmount");
    const value = parseFloat(current_cart.header.MT_REMISE);
    if (isRoleOperator()) {
      const handleRemiseChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const value = e.target.value;
        cartSDK.changeFeetRemise({
          creator: user.client_profile?.id,
          remise: value,
        });
      };
      return (
        <React.Fragment>
          <div className="remise-en-pied-container">
            <div className="remise-en-pied-label">{label}</div>
            <div className="remise-en-pied-input">
              <input
                className="input-remise-en-pied"
                type="number"
                value={value}
                onChange={handleRemiseChange}
              />
              €
            </div>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="remise-en-pied-container">
          <div className="remise-en-pied-label">{label}</div>
          <div className="remise-en-pied-value">{value} €</div>
        </div>
      </React.Fragment>
    );
  }
  function handleGoBack() {
    const isPLVEnabled = max_mt_plv_offert > 0;
    isPLVEnabled ? navigate.push(admin.PLV_PAGE) : goBack();
  }

  function renderOrderSummary() {
    return (
      <React.Fragment>
        <div className="order-summary-container">
          <div className="order-summary-header">
            <div
              className="order-summary-back-button"
              onClick={handleGoBack}
              style={{ cursor: "pointer" }}
            >
              <UiIcon icon={ICON.arrowLeftIcon} size="lg" />
              <span> Synthèse de commande</span>
            </div>
          </div>
          <div className="order-summary-content">
            <CurrentCartItems disableControls={true} />
            {/* {renderRemiseEnPied()} */}
            {renderMontantSummary()}
          </div>
        </div>
      </React.Fragment>
    );
  }

  function renderOrderFooterSection() {
    function processOrderAction(e) {
      if (orderValueLimit && getMtTotalHT() < orderValueLimit) {
        alert(
          `Votre commande ne peut être validée. Notre minimum de commande est de ${orderValueLimit} €`,
        );
        return false;
      }
      if (!headerthrowError()) {
        alert(trl.message("FinishOrderPage.Dialog.missingInformation"));
        return false;
      }
      isCreatingOrder(true);
      cartSDK.generateOrder(user.client_profile?.id, (err, data) => {
        isCreatingOrder(false);
        if (err) {
          setErrorOnCreateOrder(err.message);
        }
        isOrderComplete(true);
      });
    }

    const renderCGVLabel = () => {
      if (!current_cart) return null;
      const hrefValue = `${URL_GED}/Edoc/${current_cart.client.groupe_tarifaire.CODGRT}/cgv${current_cart.client.groupe_tarifaire.CODGRT}.pdf`;
      return (
        <React.Fragment>
          <div className="cgv-label">
            Je certifie avoir lu et accepté les{" "}
            <a
              href={hrefValue}
              target="_blank"
              rel="noopener noreferrer"
              download={true}
            >
              Conditions Générales de Vente
            </a>
          </div>
        </React.Fragment>
      );
    };

    return (
      <React.Fragment>
        <div className="order-footer-section">
          <div className="cgv-checkbox-container">
            <UiCheckbox
              checked={CGVValid}
              onChange={setCGVValid}
              label={renderCGVLabel()}
              size="lg"
              style={{ gap: "0.5rem" }}
            />
          </div>
          <div className="generate-order-button-container">
            <UiButton
              content={trl.message("FinishOrderPage.generateOrderAction")}
              disabled={getTotalWithPort() <= 0 || creatingOrder || !CGVValid}
              onClick={processOrderAction}
              size="lg"
              style={{ width: "100%" }}
            />
          </div>
        </div>
        {showOrderSuccessDialog()}
      </React.Fragment>
    );
  }

  function renderOrderForm() {
    if (!client) return null;
    if (client.PROSPECT !== "O") {
      return (
        <React.Fragment>
          <div className="order-form-container">
            <ClientRecap
              current_cart={current_cart}
              createHeader={cartSDK.createHeader}
              removeOrderHeader={cartSDK.removeOrderHeader}
              remise={0}
              frais_port={MT_PORT}
              fildValid={clientRecapValidData}
            />
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="order-form-container">
          <ProspectRecap
            current_cart={current_cart}
            createHeader={cartSDK.createHeader}
            removeOrderHeader={cartSDK.removeOrderHeader}
            remise={0}
            frais_port={MT_PORT}
            fildValid={prospectRecapValidData}
          />
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="order-synthese-container">
        {renderOrderSummary()}
        {renderOrderForm()}
        {renderOrderFooterSection()}
      </div>
    </React.Fragment>
  );
}

export default OrderSynthese;
